import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get, orderBy, isEmpty, values, isEqual } from "lodash";
import produce from "immer";
import styled from "styled-components";
import { getPractitionerPermissions, updatePractitionerPermissions } from "../../services/practitioner";
import CheckboxField from "../Shared/CheckboxField";
import Button from "../Shared/Button";
import { selectActivePractitioners } from "../appSlice";

//const NEW_APT_EMAIL = "newAptEmail";
//const REVIEW_APT_EMAIL = "reviewAptEmail";
const PREBOOKING_NOTIFICATION = "prebookingNotification";

const PractitionerPermissions = () => {
  const storedPractitioners = useSelector(selectActivePractitioners);
  const [oldPractitioners, setOldPractitioners] = useState({});
  const [practitioners, setPractitioners] = useState({});
  const [permissions, setPermissions] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [hideMessage, setHideMessage] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getPractitionerPermissions().then((data) => {
      if (!isEmpty(data)) {
        setPermissions(data);
      }
    });
  }, []);

  useEffect(() => {
    if (storedPractitioners.length > 0) {
      const data = storedPractitioners.reduce(
        (prev, curr) => ({
          ...prev,
          [curr.practitionerId]: {
            id: curr.practitionerId,
            fullName: `${curr.firstName} ${curr.lastName}`,
            newAptEmail: get(permissions, [curr.practitionerId, "newAptEmail"], false),
            reviewAptEmail: get(permissions, [curr.practitionerId, "reviewAptEmail"], false),
            prebookingNotification: get(permissions, [curr.practitionerId, "prebookingNotification"], false),
          },
        }),
        {}
      );
      setPractitioners(data);
      setOldPractitioners(data);
    }
  }, [storedPractitioners, permissions]);

  /**
   *
   * @param {string} which The permission that you want to change
   * @param {ID} who The practitioner who his/her permission will be changed
   */
  const handlePermissionChange = (which, who) => {
    setHideMessage(true);
    setErrorMessage("");
    setPractitioners((state) => {
      const newState = produce(state, (draftState) => {
        draftState[who][which] = !state[who][which];
      });
      return newState;
    });
  };

  const handleSubmitPermissions = async () => {
    setIsUpdating(true);
    setErrorMessage("");
    const { error } = await updatePractitionerPermissions(practitioners);
    setIsUpdating(false);
    if (error) {
      setErrorMessage("Practitioner permissions failed to update.");
      return;
    }
    setHideMessage(false);
  };

  if (isEmpty(practitioners)) {
    return null;
  }

  return (
    <>
      <p className="menu-label">Practitioner Permissions</p>
      <hr />
      <div className="notification is-link is-light is-size-7">
        Please select practitoners who you want to send pre-booking notification email and SMS
      </div>
      <PractitionerPermissionContainer>
        <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
          <tbody>
            <tr>
              <td>Name</td>
              {/* <td>New appointment email (not ready yet)</td>
              <td>Review appointment email (not ready yet)</td> */}
              <td>Pre-booking notification</td>
            </tr>
            {orderBy(values(practitioners), ["fullName"], "asc").map((pm) => (
              <tr key={pm.id}>
                <td>{pm.fullName}</td>
                {/* <td>
                  <CheckboxField checked={pm.newAptEmail} onChange={() => {}} />
                </td>
                <td>
                  <CheckboxField checked={pm.reviewAptEmail} onChange={() => {}} />
                </td> */}
                <td>
                  <CheckboxField
                    checked={pm.prebookingNotification}
                    onChange={() => {
                      handlePermissionChange(PREBOOKING_NOTIFICATION, pm.id);
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </PractitionerPermissionContainer>
      <hr />
      <div className="columns">
        <div className="column is-one-third">
          <Button
            text="SUBMIT"
            onClick={handleSubmitPermissions}
            isLoading={isUpdating}
            disabled={isUpdating || isEqual(oldPractitioners, practitioners)}
          />
        </div>
      </div>
      {hideMessage ? null : (
        <div className="columns">
          <div className="column is-one-third">
            <div className="notification is-success is-light is-size-7">Practitioner permissions are updated.</div>
          </div>
        </div>
      )}
      {errorMessage ? (
        <div className="columns">
          <div className="column is-one-third">
            <div className="notification is-danger is-light is-size-7">{errorMessage}</div>
          </div>
        </div>
      ) : null}
    </>
  );
};

const PractitionerPermissionContainer = styled.div`
  overflow-y: scroll;
  min-height: 80px;
  max-height: 640px;
`;

export default PractitionerPermissions;
